import { publicEnv } from '~/features/environment/public';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { REVIEW_PAGE_SIZE } from '../constants';
import { ProgramReviews, programReviewsSchema } from '../models/program-review';

export async function getProgramReviews(
  programKey: string,
  page: number,
  perPage: number = REVIEW_PAGE_SIZE
): Promise<ProgramReviews> {
  return await queryUdacityService({
    url: `${publicEnv.NEXT_PUBLIC_RATINGS_URL}/reviews/${programKey}?page=${page}&perPage=${perPage}`,
    method: 'GET',
    zodSchema: programReviewsSchema,
  });
}
